// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLandingPage_wrapper__aq0iP"};